import { Chip, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { classnameIcon, generarteHeight, generateBlod, generateWidthPreview } from '../../utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DialogPreviewFile from '../dialog/DialogPreviewFile';

const ChipMedia = ({ data = {}, onDelete, disabled, simple }) => {
  const [show, setShow] = useState(false);
  const width = generateWidthPreview(data.mimetype);
  const height = generarteHeight(data.mimetype);
  const size = simple ? 9 : 14;
  const label = data.description ? data.description : data.name;

  const onClick = (e) => {
    e.stopPropagation();
    if (disabled) return;
    if (data.type === 'file') {
      setShow(true);
    }
  };
  return (
    <>
      {show && (
        <DialogPreviewFile
          width={width}
          height={height}
          data={data}
          show={show}
          onClose={(e) => {
            e.stopPropagation();
            setShow(false);
          }}
        />
      )}
      <Tooltip arrow placement='top' title={label}>
        <Chip
          className={simple ? 'max-w-50px': 'max-w-180px'}
          onDelete={onDelete}
          onClick={onClick}
          style={{
            height: simple ? '1.5rem': '2rem',
            padding: simple ? '0.25rem': '0.5rem'
          }}
          classes={{
            label: 'px-1',
            deleteIcon: 'm-0'
          }}
          avatar={
            <div
              className='p-1 rounded-full flex items-center justify-center'
              style={{
                width: size,
                height: size,
                margin: 0,
                backgroundColor: classnameIcon(data.mimetype, data.type)
              }}
            >
              <FontAwesomeIcon
                style={{ fontSize: simple ? '0.95em' : '1.2em' }}
                className='text-white'
                icon={generateBlod(data.mimetype, data.type)}
              />
            </div>
          }
          label={
            <Typography
              noWrap
              className={['text-ellipsis', simple ? 'text-xs' : 'text-sm'].join(' ')}
              component={data.type === 'link' ? 'a' : 'span'}
              href={data.link}
              target='_blank'
            >
              {label}
            </Typography>
          }
        />
      </Tooltip>
    </>
  );
};

export default ChipMedia;
